var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"subdued",attrs:{"to":{ name: 'personDetail', params: { personId: _vm.person.pk } }}},[_c('PersonName',{attrs:{"person":_vm.person,"phonebook":_vm.phonebook}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }